/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { sendErrorMessage, displayModal } from '@insticator/insticator-ui'; // iui-state
import { invalidateActiveAddOn } from 'state/actions/embedsState/embedManagementState/content_status';
import { toggleAddOnItem, setEditingAddOn } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { discardAddOnChanges } from 'state/actions/embedsState/embedManagementState/content_status';
import { discardEmbedChanges } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import AddOnsPage from 'pages/dashboard/embeds/management/addons/addons';
import {batchActions} from "redux-batched-actions";



/* ========== ~~~~~~~~~~ EMBED REVENUE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { handleSaveEmbed }) => ({
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    selectedEmbedData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    editingAddOn: embedsState.embedManagementState.selectedEmbedStatus.editingAddOn,
    emailCollectionDataPresent: embedsState.embedManagementState.contentStatus.addons.userDataCollection.dataPresent,
    userDataCollection: embedsState.embedManagementState.contentStatus.addons.userDataCollection,
    isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    handleSaveEmbed
});

// map actions
const mapDispatchToProps = dispatch => ({
    discardChanges: () => dispatch(batchActions([
        discardAddOnChanges(),
        discardEmbedChanges()
    ])),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => {
        dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
    },
    toggleAddOnItem: (itemToToggle) => dispatch(toggleAddOnItem(itemToToggle)),
    setEditingAddOn: (addOn) => dispatch(setEditingAddOn(addOn)),
    invalidateActiveAddOn: (addOn) => dispatch(invalidateActiveAddOn(addOn)),
    sendErrorMessage: message => dispatch(sendErrorMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddOnsPage);
